import { firebaseApp } from './firebase-loader';

export const storage = firebaseApp.then(() => window.firebase.storage())
